import React from "react";

const ProductCardSkeleton = () => {
  return (
    <div className="mb-12">
      <div className="flex flex-col items-center gap-4 p-6 sm:p-8 rounded-2xl w-full max-w-[640px] mx-auto text-center border border-white/10 bg-slate-900/50 animate-pulse">
        {/* Icon */}
        <div className="h-16 w-16 bg-slate-700/50 rounded-full mb-2" />
        
        {/* Title & Description */}
        <div className="h-8 w-48 bg-slate-700/50 rounded-lg mb-2" />
        <div className="h-4 w-32 bg-slate-700/30 rounded-lg mb-6" />

        {/* Items Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 w-full px-2">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="flex flex-col gap-2 p-3 bg-slate-800/50 rounded-xl items-center">
              {/* Image/Icon */}
              <div className="w-16 h-16 bg-slate-700/50 rounded-lg" />
              {/* Text */}
              <div className="h-4 w-12 bg-slate-700/50 rounded mt-2" />
              {/* Button */}
              <div className="h-8 w-full bg-slate-700/50 rounded-lg mt-2" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductCardSkeleton;
